import React from 'react';
import { Link } from 'react-router-dom';

const MapUnavailable = () => (
	<div className="mapUnavailable" role="status">
		<div className="mapUnavailableCard">
			<div className="mapUnavailableIcon" aria-hidden="true">
				<span className="glyphicon glyphicon-map-marker"></span>
			</div>
			<h2>Map is unavailable</h2>
			<p>
				This project has no KML configured, so Map cannot show overlays or placemarks.
				Upload a KML (and overlay, if needed) in Project Setup.
			</p>
			<p className="mapUnavailableHint">
				Map requires KML — configure in Project Setup.
			</p>
			<Link className="btn btn-primary" to="/setup/">
				Open Project Setup
			</Link>
		</div>
	</div>
);

export default MapUnavailable;
